import styles from "./PaymentSuccess.module.css";

export default function PaymentFailed() {
  const params = new URLSearchParams(window.location.search);
  const reason = params.get("reason") || "Your payment could not be completed.";

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.iconFail}>✕</div>
        <h1 className={styles.title}>Payment Failed</h1>
        <p className={styles.body}>
          {reason}
        </p>
        <p className={styles.body} style={{ fontSize: 13, opacity: 0.7 }}>
          No amount has been charged. Please try again or contact us for help.
        </p>
        <p className={styles.contact}>
          Need help? WhatsApp us at{" "}
          <a href="https://wa.me/94765851400">+94 76 585 1400</a>
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button className={styles.homeBtn} onClick={() => window.location.href = "/checkout"}>
            Try Again
          </button>
          <button className={styles.homeBtnOutline} onClick={() => window.location.href = "/"}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}